import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Button, Description, DescriptionItem, Link, Row } from '@app/components'
//import { IStore } from '@app/redux'
//import { auth } from '@app/services'
import { Col } from 'antd'
//import axios from 'axios'
//import { isEmpty } from 'lodash'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { ZellePayQRCode } from '~public'
//import { useSelector } from 'react-redux'

export const ZellePayContent: React.FC<any> = ({ /*setCurrentNode, userCountry,*/ userMemo }) => {
  //const { user } = useSelector((state: IStore) => state)
  const componentRef = useRef()
  const { fetchUserInfo } = useContext(UserInfoContext)

  //const [result, setResult] = useState<string | object>({})

  //   const descriptionItemStyle: React.CSSProperties = {
  //     textAlign: 'right',
  //     display: 'block',
  //   }

  const [bankDetails, setBankDetails] = useState({
    recipientEmail: '',
    memo: '',
  })
  // Function to get bank details based on the last character of userMemo
  const getBankDetails = (userMemo) => {
    /*const lastChar = userMemo.slice(-1) // Get the last character of userMemo

    if (usa == true && !state) {
      return {
        accountNumber: '4000011900',
        routingNumber: '103113441',
        recipientName: 'CTS Global',
        recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
        bankName: 'Old Glory Bank',
        memo: userMemo,
      }
    } else if (/[A-M]/.test(lastChar)) {
      // Last character is a-z
      return {
        accountNumber: '4000011900',
        routingNumber: '103113441',
        recipientName: 'CTS Global',
        recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
        bankName: 'Old Glory Bank',
        memo: userMemo,
      }
    } else if (/[0-9]/.test(lastChar)) {
      // Last character is 0-9
      return {
        accountNumber: '4000011900',
        routingNumber: '103113441',
        recipientName: 'CTS Global',
        recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
        bankName: 'Old Glory Bank',
        memo: userMemo,
      }
    } else if (/[N-Z]/.test(lastChar)) {*/
    if (userMemo) {
      // Last character is A-Z
      return {
        recipientEmail: 'Accounts@ctsglobal.io',
        memo: userMemo,
      }
    } else {
      // Default or invalid character handling
      return {
        recipientEmail: '',
        memo: '',
      }
    }
  }

  // Get the bank details based on userMemo
  useEffect(() => {
    const tmpDetails = getBankDetails(userMemo)
    //console.log(bankDetails);
    setBankDetails(tmpDetails)
  }, [userMemo])

  useEffect(() => {
    fetchUserInfo()
  }, [])

  return (
    <Row gutter={[30, 30]}>
      <Col span={24} ref={componentRef}>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <>
              <Description column={1}>
                <DescriptionItem label="Create Account">
                  <Link href={'https://www.zellepay.com/'} target="_blank">
                    zellepay.com
                  </Link>
                </DescriptionItem>
                <DescriptionItem label="Recipient Email">{bankDetails.recipientEmail}</DescriptionItem>
                <DescriptionItem label="Memo/Reference (Required)">{bankDetails.memo}</DescriptionItem>
                <DescriptionItem label="QR Code">
                  <ZellePayQRCode style={{ height: '200px' }} />
                </DescriptionItem>
              </Description>

              <Row>
                <Col span={24}>
                  <Button
                    block
                    style={{ backgroundColor: '#FFFFFF', color: '#2d54a4', borderColor: '#2d54a4' }}
                    href="https://intercom.help/0xcoast/en/articles/9718093-funding-your-coast-account-with-old-glory-pay"
                    target="_blank"
                  >
                    Deposit Instructions
                  </Button>
                </Col>
                {/*<Col span={12}>
                    <Button block href="https://wise.com/send/" target="_blank">
                      Start a Deposit
                    </Button>
                    </Col>*/}
              </Row>
            </>
          </Col>

          {/*<Col>
            <Button type="default" icon={<DownloadOutlined />} onClick={handleImageSave}>
              Download
            </Button>
            </Col>*/}
        </Row>
      </Col>
    </Row>
  )
}
